import langKeys from '@sdui-hq/app-internationalization/locales/de.json'
import type {Metadata} from '@/types/config/brandings/metadata.ts'

const sduiDefaultLangKeys = langKeys.variables.DEFAULT.DEFAULT

const generateDefaultHtmlMetadata = (): Metadata => {
  return {
    title: sduiDefaultLangKeys.APP_NAME,
    meta: {
      description: langKeys.login.login_sign_in.page_default_description
        .replace('@:{\'_vars.APP_NAME_LANG_HELPER.NOM_BEGIN\'}', sduiDefaultLangKeys.APP_NAME_LANG_HELPER.NOM_BEGIN)
        .replace('@:{\'_vars.SCHOOL_LANG_HELPER.PLURAL\'}', sduiDefaultLangKeys.SCHOOL_LANG_HELPER.PLURAL)
        .replace('@:{\'_vars.SCHOOL\'}', sduiDefaultLangKeys.SCHOOL),
      author: sduiDefaultLangKeys.COMPANY_NAME,
      copyright: sduiDefaultLangKeys.COMPANY_NAME,
      applicationName: sduiDefaultLangKeys.APP_NAME,
      appleItunesApp: 'app-id=1145264453',
      open_graph: {
        url: sduiDefaultLangKeys.APP_URL,
        image: `${sduiDefaultLangKeys.APP_URL_FULL}/favicons/favicon_192x192.png`
      }
    },
    link: {
      copyrightLink: sduiDefaultLangKeys.IMPRINT_LINK,
      favIcon: '/favicon.ico'
    }
  }
}

export default generateDefaultHtmlMetadata
